module.exports = __webpack_public_path__ + "img/BET.c9038af6.png";